'use strict';

/* eslint max-lines: 0 */
/* eslint max-lines-per-function: 0 */
/* eslint quote-props: 0  */

var Page           = require('stb-component-page'),
    app            = require('mag-app'),

    dom            = require('spa-dom'),
    keys           = require('stb-keys'),

    PanelSet       = require('mag-component-panel-set'),
    Panel          = require('mag-component-panel'),
    TabItem        = require('spa-component-tab'),

    ModalMessage   = require('mag-component-modal'),
    LayoutList     = require('mag-component-layout-list'),
    ScrollArea     = require('mag-component-scroll-area'),
    Scrollbar      = require('stb-component-scrollbar'),

    prepareSeasons = require('../utils/prepare.seasons'),
    prepareFiles   = require('../utils/prepare.files'),
    sortQuality    = require('../utils/sort.quality'),
    parseTime      = require('../utils/parse.time'),

    page = new Page({$node: document.getElementById('pageInfo')}),

    textArea, actionModal,
    // actionListModal,
    scrollList = new Scrollbar({}),
    types = {
        active: 1,
        file: 1,
        season: 2,
        series: 3
    },
    configRequest = {},
    historyStack = [],
    infoTable = [],
    infoData = null,
    tag = dom.tag,

    listAction, leftList, footer, Footer,
    panelSet, infoPanel, leftPanel,
    descriptionItem, playItem,
    $poster, $info, $description, $favorite,
    scroll, playText, seasonTitle,
    playList,
    playModal, refreshData, refreshPlayList,
    pressOk, modalPlayList,
    playHistory, leftListData;


if ( TARGET !== 'android-stb' && TARGET !== 'android-app'  ) {
    Footer = require('mag-component-footer');
    footer = new Footer({visible: false, parent: page});
}


/**
 * Back function.
 */
function moveBack () {
    var item;

    if ( historyStack.length === 0 ) {
        app.route(app.pages.main);

        return;
    }

    item = historyStack.pop();
    types.active = item.type;
    playList.setData({focusIndex: item.focus, data: item.data});
    playText = item.title;
    infoPanel.title.links.$name.innerText = playText;
}


/**
 * Prepare object to play.
 *
 * @param {Object} data - data to play
 * @param {Object} config - config to prepare
 */
function prepareToPlay ( data, config ) {
    var selectFile = require('../utils/select.file'),

        activeItem = data || playList.$focusItem.value,
        name = infoData.name,
        languages = [],
        hasNext = false,
        hasPrevios = false,
        previosHandler = null,
        nextHandler = null,
        // playerContext = config && config.context,
        // intent = config && config.intent,
        item;

    config = config || {};

    function checkFile () {
        var file;

        file = selectFile(playList.data.slice(1), languages, config.intent.data.file);

        if ( file ) {
            playList.focusIndex(file.index);
            prepareToPlay(file.value, config);
        } else {
            config.playerContext = null;
            config.intent.close();
        }
    }

    function selectNextFile ( code ) {
        var needTitle = true;

        languages = config.playerContext.metadata.audioLang;
        app.pages.main.saveVideo(function () {
            refreshData(true);
        }, config, true);

        switch ( types.active ) {
            case types.file:
                moveBack();
                needTitle = false;
            /* eslint no-fallthrough: 0 */
            case types.series:
                playList.move(code);
                if ( needTitle ) {
                    playText = historyStack[historyStack.length - 1].title;
                }
                pressOk(checkFile);
                break;
            /* eslint no-fallthrough: 2 */
        }
    }

    function closeIntent () {
        app.pages.main.saveVideo(refreshData, config);
        config.playerContext = null;
        config.intent.close();
    }

    if ( infoData['is_tv_series'] ) {
        switch ( types.active ) {
            case types.file:
                item = historyStack[historyStack.length - 1];
                hasNext = item.focus + 1 < item.data.length;
                hasPrevios = item.focus > 1;
                break;
            case types.series:
                hasNext = playList.$focusItem.index + 1 < playList.data.length;
                hasPrevios = playList.$focusItem.index > 1;
                break;
        }

        if ( hasNext ) {
            nextHandler = function () {
                selectNextFile(keys.down);
            };
        }
        if ( hasPrevios ) {
            previosHandler = function () {
                selectNextFile(keys.up);
            };
        }
    }

    playHistory = {
        data: playList.data,
        focus: playList.$focusItem.index,
        type: types.active
    };

    /**
     * Play object.
     *
     * @param {boolean} error - have some error
     * @param {string} uri - uri to play
     */
    function play ( error, uri ) {
        if ( error ) {
            return;
        }

        if ( infoData['is_tv_series'] && historyStack.length ) {
            name += ' ' + seasonTitle + ' ' + playText;
        }


        function startPlay ( position ) {
            var season, episode;

            if ( infoData['is_tv_series'] && historyStack.length ) {
                episode = historyStack[historyStack.length - 1];
                episode = episode.data[episode.focus];
                season = historyStack[0];
                season = season.data[season.focus];
            }

            config.intent = core.intent({
                action: 'play',
                mime: 'content/video',
                data: {
                    title: name,
                    uri: uri,
                    movie: infoData,
                    file: activeItem,
                    season: season,
                    episode: episode,
                    position: position,
                    subtitles: activeItem.subtitleList,
                    mediaId: activeItem.id
                },
                events: {
                    end: function () {
                        app.pages.main.saveVideo(refreshData, config, true);

                        if ( nextHandler ) {
                            nextHandler();

                            return;
                        }
                        config.playerContext = null;
                        config.intent.close();
                    },
                    error: closeIntent,
                    stop: closeIntent,
                    hide: closeIntent,
                    next: nextHandler,
                    prev: previosHandler,
                    close: function () {
                        if ( config.playerContext ) {
                            app.pages.main.saveVideo(refreshData, config);
                            config.playerContext = null;
                        }
                    }
                },
                context: config.playerContext
            }, function ( error, context ) {
                debug.fail('Play error', error);
                config.playerContext = context;
                if ( DEVELOP ) {
                    window.context1 = context;
                }
            });
        }

        if ( activeItem.watched_time && activeItem.watched_status === 'not_ended' && !config.playerContext ) {
            panelSet.blur();
            playModal.show({file: activeItem, movie: infoData, callback: startPlay, name: name});

            if ( config.intent ) {
                config.intent.close();
            }

            return;
        }

        startPlay(0);
    }

    if ( activeItem.url ) {
        play(false, activeItem.url);
    } else {
        infoData.getUrl(activeItem.id, play);
    }
}


/**
 * Add/remove to/from favorites.
 */
function favorite () {
    var favoriteLinks;

    if ( TARGET === 'android-stb' || TARGET === 'android-app' ) {
        favoriteLinks = leftList.links.favorite.links;
    }

    if ( infoData.favorite ) {
        $favorite.style.display = 'none';
        if ( TARGET === 'android-stb' || TARGET === 'android-app' ) {
            favoriteLinks.$icon.className = 'theme-icon theme-icon-favorite';
            favoriteLinks.$title.innerText = gettext('Add to favorite');
        }
    } else {
        $favorite.style.display = 'block';
        if ( TARGET === 'android-stb' || TARGET === 'android-app' ) {
            favoriteLinks.$icon.className = 'theme-icon theme-icon-favorite-active active';
            favoriteLinks.$title.innerText = gettext('Remove from favorites');
        }
    }

    app.emit('change:favorite', {
        video: infoData,
        callback: function ( error ) {
            if ( error ) {
                if ( infoData.favorite ) {
                    $favorite.style.display = 'block';
                    if ( TARGET === 'android-stb' || TARGET === 'android-app' ) {
                        favoriteLinks.$icon.className = 'theme-icon theme-icon-favorite-active active';
                        favoriteLinks.$title.innerText = gettext('Remove from favorites');
                    }
                } else {
                    $favorite.style.display = 'none';
                    if ( TARGET === 'android-stb' || TARGET === 'android-app' ) {
                        favoriteLinks.$icon.className = 'theme-icon theme-icon-favorite';
                        favoriteLinks.$title.innerText = gettext('Add to favorite');
                    }
                }
            }
        }
    });
}


// function setWatched ( add, infoFlag ) {
//     var activeItem = playList.$focusItem,
//         season, episode, files,
//         flag;
//
//     function checked ( error, data ) {
//         if ( error || !data.status ) {
//             return;
//         }
//
//         infoData['watched_status'] = data['movie_watched_status'];
//         if ( flag ) {
//             flag.value['watched_status'] = add ? 'watched' : 'not_watched';
//             flag.items[1].className = add ? 'theme-icon theme-icon-ok' : 'theme-icon theme-icon-ok hidden';
//         }
//         if ( season ) {
//             if ( data['season_watched_status'] ) {
//                 season.value['watched_status'] = data['season_watched_status'];
//             } else {
//                 season.value['watched_status'] = add ? 'watched' : 'not_watched';
//             }
//
//             switch ( season.value['watched_status'] ) {
//                 case 'watched':
//                     season.items[1].className = 'theme-icon theme-icon-ok';
//                     break;
//
//                 case 'not_watched':
//                     season.items[1].className = 'theme-icon theme-icon-ok hidden';
//                     break;
//
//                 case 'not_ended':
//                     season.items[1].className = 'theme-icon theme-icon-ok disabled';
//                     break;
//             }
//         }
//
//         if ( episode ) {
//             episode.items[1].className = add ? 'theme-icon theme-icon-ok' : 'theme-icon theme-icon-ok hidden';
//         }
//
//         refreshPlayList();
//         app.pages.main.refreshList(true);
//     }
//
//     if ( infoFlag ) {
//         infoData.changeFlags({'watched_status': add ? 'watched' : 'not_watched'}, function ( error, data ) {
//             var index, status;
//
//             if ( !error && data ) {
//                 infoData['watched_status'] = status = add ? 'watched' : 'not_watched';
//                 if ( !infoData['is_tv_series'] ) {
//                     for ( index = 0; index < infoData.files.length; index++ ) {
//                         infoData.files[index]['watched_status'] = status;
//                     }
//                 }
//                 refreshPlayList();
//                 app.pages.main.refreshList(true);
//             }
//         });
//     } else {
//         switch ( types.active ) {
//             case types.file:
//                 if ( infoData['is_tv_series'] && historyStack.length ) {
//                     episode = historyStack[1];
//                     episode = episode.data[episode.focus];
//                     season = historyStack[0];
//                     season = season.data[season.focus];
//                 }
//                 flag = activeItem.data;
//                 infoData.changeWatchedFile(activeItem.value.id,
//                     {'watched_status': add ? 'watched' : 'not_watched', 'watched_time': 0}, checked);
//                 break;
//
//             case types.season:
//                 season = activeItem.data;
//                 infoData.changeWatchedSeason(activeItem.value.id,
//                     {'watched_status': add ? 'watched' : 'not_watched', 'watched_time': 0}, checked);
//                 break;
//
//             case types.series:
//                 if ( infoData['is_tv_series'] && historyStack.length ) {
//                     season = historyStack[0];
//                     season = season.data[season.focus];
//                     files = activeItem.value.files;
//                 }
//                 if ( files.length ) {
//                     infoData.changeWatchedFile(files[0].id, {'watched_status': add ? 'watched' : 'not_watched', 'watched_time': 0},
//                         function ( error, data ) {
//                             var index;
//
//                             if ( error ) {
//                                 return;
//                             }
//
//                             episode = activeItem.data;
//                             checked(error, data);
//                             for ( index = 1; index < files.length; index++ ) {
//                                 infoData.changeWatchedFile(files[index].id, {'watched_status': add ? 'watched' : 'not_watched'},
//                                     function () { return false; });
//                             }
//                         });
//                 }
//                 break;
//         }
//     }
//
// }


/**
 * Click function.
 *
 * @param {Function} [callback] - result handler
 */
pressOk = function ( callback ) {
    var activeItem = playList.$focusItem.value,
        list = [];

    if ( DEVELOP ) {
        window.h = historyStack;
    }
    switch ( types.active ) {
        case types.file:
            prepareToPlay();
            break;

        case types.season:
            historyStack.push({
                type: types.season,
                data: playList.data,
                title: playText,
                focus: playList.$focusItem.index
            });
            playText = playList.$focusItem.data.items[0].value;
            seasonTitle = playText;
            infoPanel.title.links.$name.innerText = seasonTitle;
            configRequest.seasonId = activeItem.id;
            infoData.getSeries(activeItem.id, function ( error, data ) {
                list = error ? [] : prepareSeasons(data, true);
                list.unshift({
                    items: [
                        {
                            className: 'theme-icon theme-icon-back'
                        },
                        {
                            className: 'title',
                            value: '. .'
                        }

                    ],
                    value: null
                });
                types.active = types.series;
                playList.setData({focusIndex: 0, data: list});
                if ( callback ) {
                    callback();
                }
            });
            break;

        case types.series:
            historyStack.push({
                type: types.series,
                data: playList.data,
                title: seasonTitle,
                focus: playList.$focusItem.index
            });
            configRequest.episodeId = activeItem.id;
            playText = playList.$focusItem.data.items[0].value;
            infoData.getEpisode(configRequest, function ( error, data ) {
                list = error ? [] : prepareFiles(infoData, data.files);

                if ( list.length === 1 && !callback ) {
                    prepareToPlay(list[0].value);
                    historyStack.pop();

                    return;
                }

                infoPanel.title.links.$name.innerText = playText;
                list.unshift({
                    items: [
                        {
                            className: 'theme-icon theme-icon-back'
                        },
                        {
                            className: 'title',
                            value: '. .'
                        }

                    ],
                    value: null
                });
                types.active = types.file;
                playList.setData({focusIndex: 0, data: list});
                if ( callback ) {
                    callback();
                }
            });
            break;
    }
};


refreshData = function ( noRefresh ) {
    var item;

    switch ( types.active ) {
        case types.file:
            if ( playHistory.type !== types.active || playHistory.data !== playList.data || noRefresh ) {
                return;
            }

            item = playHistory.data[playHistory.focus];
            switch ( item.value.watched_status ) {
                case 'watched':
                    item.items[1].className = 'theme-icon theme-icon-ok';
                    break;
                case 'not_watched':
                    item.items[1].className = 'theme-icon theme-icon-ok hidden';
                    break;
                case 'not_ended':
                    item.items[1].className = 'theme-icon theme-icon-ok disabled';
                    break;
            }
    }
    playHistory = null;
    refreshPlayList();
};


refreshPlayList = function () {
    if ( playList.data.length && playList.$focusItem ) {
        playList.setData({data: playList.data, focusIndex: playList.$focusItem.index});
    }
};


descriptionItem = new TabItem({
    propagate: true,
    focusable: true,
    events: {
        focus: function () {
            textArea.focus();
        },
        keydown: function ( event ) {
            var name = infoData.name,
                subtitleList = [],
                file, files, intent, playerContext, index;

            //Play focus item.
            function play ( error, url ) {

                function closeIntent () {
                    app.pages.main.saveVideo(null, {intent: intent, playerContext: playerContext});
                    playerContext = null;
                    intent.close();
                }

                function startPlay ( position ) {
                    intent = core.intent({
                        action: 'play',
                        mime: 'content/video',
                        data: {
                            title: name,
                            uri: url,
                            movie: infoData,
                            file: file,
                            position: position,
                            externalSubtitles: subtitleList,
                            mediaId: file.id
                        },
                        events: {
                            end: function () {
                                app.pages.main.saveVideo(null, {intent: intent, playerContext: playerContext}, true);
                                playerContext = null;
                                intent.close();
                            },
                            error: closeIntent,
                            stop: closeIntent,
                            hide: closeIntent,
                            next: null,
                            prev: null,
                            close: function () {
                                if ( playerContext ) {
                                    app.pages.main.saveVideo(null, {intent: intent, playerContext: playerContext});
                                }
                            }
                        },
                        context: playerContext
                    }, function ( error, context ) {
                        debug.fail('Playing error', error);
                        playerContext = context;
                    });
                }

                if ( error ) {
                    return;
                }


                if ( file.watched_status === 'not_ended' && file.watched_time ) {
                    panelSet.blur();
                    playModal.show({file: file, movie: infoData, callback: startPlay});

                    if ( intent ) {
                        intent.close();
                    }

                    return;
                }

                startPlay(0);
            }

            switch ( event.code ) {
                case keys.ok:
                    leftList.focusIndex(1);
                    infoPanel.title.links.$name.innerText = playText;
                    playItem.show();
                    infoPanel.focus();
                    if ( !infoData['is_tv_series'] && playList.data.length === 1 ) {
                        prepareToPlay();
                    }
                    break;

                case keys.playPause:
                    if ( infoData['is_tv_series'] ) {
                        if ( playList.data.length ) {
                            if ( infoData.last_watched_season_id ) {
                                for ( index = 0; index < playList.data.length; index++ ) {
                                    if ( infoData.last_watched_season_id === playList.data[index].value.id ) {
                                        playList.focusIndex(index);
                                        break;
                                    }
                                }
                            }
                            pressOk(function () {
                                var selectedIndex = 1;

                                if ( playList.data.length > 1 ) {
                                    if ( infoData.last_watched_episode_id ) {
                                        for ( index = 1; index < playList.data.length; index++ ) {
                                            if ( infoData.last_watched_episode_id === playList.data[index].value.id ) {
                                                selectedIndex = index;
                                                break;
                                            }
                                        }
                                    }
                                    playList.focusIndex(selectedIndex);

                                    pressOk(function () {
                                        if ( playList.data.length > 1 ) {
                                            selectedIndex = 1;
                                            if ( infoData.last_watched_file_id ) {
                                                for ( index = 1; index < playList.data.length; index++ ) {
                                                    if ( infoData.last_watched_file_id === playList.data[index].value.id ) {
                                                        selectedIndex = index;
                                                        break;
                                                    }
                                                }
                                            }
                                            playList.focusIndex(selectedIndex);
                                            playItem.show();
                                            infoPanel.focus();
                                            pressOk();
                                        } else {
                                            playItem.show();
                                            infoPanel.focus();
                                        }

                                    });
                                } else {
                                    playItem.show();
                                    infoPanel.focus();
                                }
                            });
                        }
                    } else {
                        if ( infoData['last_watched_file_id'] ) {
                            for ( index = 0; index < infoData.files.length; index++ ) {
                                if ( infoData['last_watched_file_id'] === infoData.files[index].id ) {
                                    file = infoData.files[index];
                                    if ( file.url ) {
                                        play(false, file.url);
                                    } else {
                                        infoData.getUrl(file.id, play);
                                    }

                                    return;
                                }
                            }
                        }
                        files = sortQuality(infoData, infoData.files);
                        subtitleList = files.subtitles;
                        files = files.video;
                        if ( files.length ) {
                            file = files[0];
                        } else {
                            return;
                        }
                        if ( file.url ) {
                            play(false, file.url);
                        } else {
                            infoData.getUrl(file.id, play);
                        }
                    }
                    break;
            }
        }
    }
});


playList = new LayoutList({
    focusIndex: 0,
    size: 7,
    className: 'padded playList',
    propagate: true,
    focusable: true,
    fixedData: true,
    cycle: true,
    events: {
        'click:item': function ( event ) {
            if ( !event.$item.data.value && historyStack.length ) {
                moveBack();

                return;
            }
            pressOk();
        }
        // focus: function () {
        //     if ( TARGET !== 'android-stb' && TARGET !== 'android-app'  ) {
        //         footer.init({
        //             left: {
        //                 code: keys.menu,
        //                 action: favorite
        //             }
        //         });
        //         footer.show();
        //     }
        //
        // },
        // blur: function () {
        //     if ( TARGET !== 'android-stb' && TARGET !== 'android-app'  ) {
        //         footer.hide();
        //     }
        // }

    },
    scroll: scrollList
});


playItem = new TabItem({
    propagate: true,
    focusable: true,
    children: [playList, scrollList],
    events: {
        focus: function () {
            playList.focus();
        }
    }
});


if ( TARGET === 'android-stb' || TARGET === 'android-app' ) {
    leftListData = [
        {
            name: 'play',
            items: [
                {
                    className: 'theme-icon theme-icon-play'
                },
                {
                    name: '$title',
                    value: gettext('Play')
                }
            ],
            click: function () {
                infoPanel.title.links.$name.innerText = playText;
                playItem.show();
                infoPanel.focus();
                if ( !infoData['is_tv_series'] && playList.data.length === 1 ) {
                    prepareToPlay();
                }
            }
        },
        {
            items: [
                {
                    className: 'theme-icon theme-icon-categories'
                },
                {
                    value: gettext('Description')
                }
            ],
            click: function () {
                descriptionItem.show();
                infoPanel.title.links.$name.innerText = gettext('Description');
                infoPanel.focus();
            }
        },
        {
            name: 'favorite',
            items: [
                {
                    name: '$icon',
                    className: 'theme-icon theme-icon-favorite'
                },
                {
                    name: '$title',
                    value: gettext('Add to favorite')
                }
            ],
            click: favorite
        }
    ];
} else {
    leftListData = [
        {
            items: [
                {
                    className: 'theme-icon theme-icon-categories'
                },
                {
                    value: gettext('Description')
                }
            ],
            click: function () {
                descriptionItem.show();
                infoPanel.title.links.$name.innerText = gettext('Description');
                infoPanel.focus();
                //textArea.focus();
            }
        },
        {
            name: 'play',
            items: [
                {
                    className: 'theme-icon theme-icon-play'
                },
                {
                    name: '$title',
                    value: gettext('Play')
                }
            ],
            click: function () {
                infoPanel.title.links.$name.innerText = playText;
                playItem.show();
                infoPanel.focus();
                if ( !infoData['is_tv_series'] && playList.data.length === 1 ) {
                    prepareToPlay();
                }
            }
        }
    ];
}

leftPanel = new Panel({
    title: [
        {
            value: gettext('Section'),
            className: 'name'
        }
    ],
    children: [
        leftList = new LayoutList({
            focusIndex: 0,
            size: 7,
            // className: 'padded',
            fixedData: true,
            cycle: true,
            data: leftListData
        })
    ]
});


infoPanel = new Panel({
    title: [
        {
            name: '$name',
            value: gettext('Description'),
            className: 'name'
        }
    ],
    main: true,
    size: 2,
    children: [descriptionItem, playItem],
    events: {
        focus: function () {
            if ( this.currentTab ) {
                this.currentTab.focus();
            } else {
                Panel.prototype.defaultEvents.focus.call(this);
            }
        }
    }
});


panelSet = new PanelSet({
    visible: false,
    panels: [leftPanel, infoPanel]
});
page.add(panelSet);


if ( TARGET !== 'android-stb' && TARGET !== 'android-app' ) {
    actionModal = new ModalMessage({
        title: gettext('Actions'),
        className: 'width2x',
        events: {
            show: function () {
                var linksFavorite = listAction.links.favorite.links;
                // linksWatchedStatus = listAction.links.watchedStatus.links;

                if ( infoData.favorite ) {
                    linksFavorite.$icon.className = 'theme-icon theme-icon-favorite-active active';
                    linksFavorite.$title.innerText = gettext('Remove from favorites');
                } else {
                    linksFavorite.$icon.className = 'theme-icon theme-icon-favorite';
                    linksFavorite.$title.innerText = gettext('Add to favorite');
                }

                // if ( infoData['watched_status'] === 'watched' ) {
                //     linksWatchedStatus.$icon.className = 'theme-icon';
                //     linksWatchedStatus.$title.innerText = gettext('Remove from watched');
                // } else {
                //     linksWatchedStatus.$icon.className = 'theme-icon theme-icon-ok';
                //     linksWatchedStatus.$title.innerText = gettext('Mark as watched');
                // }
            },
            hide: function () {
                panelSet.focus();
            }
        },
        children: [
            listAction = new LayoutList({
                size: 1,
                focusIndex: 0,
                cycle: true,
                fixedData: true,
                data: [
                    {
                        name: 'favorite',
                        items: [
                            {
                                name: '$icon',
                                className: 'theme-icon theme-icon-favorite'
                            },
                            {
                                name: '$title',
                                className: 'title',
                                value: gettext('Add to favorite')
                            }
                        ],
                        click: function () {
                            actionModal.hide();
                            favorite();
                        }
                    }
                    // {
                    //     name: 'watchedStatus',
                    //     items: [
                    //         {
                    //             name: '$icon',
                    //             className: 'theme-icon theme-icon-ok'
                    //         },
                    //         {
                    //             name: '$title',
                    //             className: 'title',
                    //             value: gettext('Mark as watched')
                    //         }
                    //     ],
                    //     click: function () {
                    //         actionModal.hide();
                    //         setWatched(true, true);
                    //     }
                    // }
                ],
                events: {
                    keydown: function ( event ) {
                        LayoutList.prototype.defaultEvents.keydown.call(this, event);
                        switch ( event.code ) {
                            case keys.menu:
                            case keys.back:
                                actionModal.hide();
                                event.stop = true;
                                break;
                            case keys.left:
                            case keys.right:
                                event.stop = true;
                                break;
                        }
                    }
                }
            })
        ]
    });
    page.add(actionModal);


    // actionListModal = new ModalMessage({
    //     title: gettext('Actions'),
    //     className: 'width2x',
    //     events: {
    //         show: function () {
    //             //this.children[0].focus();
    //         },
    //         hide: function () {
    //             panelSet.focus();
    //         }
    //     },
    //     children: [
    //         new LayoutList({
    //             size: 2,
    //             focusIndex: 0,
    //             cycle: true,
    //             fixedData: true,
    //             className: 'padded',
    //             data: [
    //                 {
    //                     items: [
    //                         {
    //                             className: 'title',
    //                             value: gettext('Mark as watched')
    //                         }
    //                     ],
    //                     click: function () {
    //                         actionListModal.hide();
    //                         setWatched(true);
    //                     }
    //                 },
    //                 {
    //                     items: [
    //                         {
    //                             className: 'title',
    //                             value: gettext('Mark as unwatched')
    //                         }
    //                     ],
    //                     click: function () {
    //                         actionListModal.hide();
    //                         setWatched(false);
    //                     }
    //                 }
    //             ],
    //             events: {
    //                 keydown: function ( event ) {
    //                     LayoutList.prototype.defaultEvents.keydown.call(this, event);
    //                     switch ( event.code ) {
    //                         case keys.menu:
    //                         case keys.back:
    //                             actionListModal.hide();
    //                             event.stop = true;
    //                             break;
    //                         case keys.left:
    //                         case keys.right:
    //                             event.stop = true;
    //                             break;
    //                     }
    //                 }
    //             }
    //         })
    //     ]
    // });
    // page.add(actionListModal);
}


playModal = new ModalMessage({
    visible: false,
    title: gettext('Play'),
    className: 'width2x',
    events: {
        show: function ( data ) {
            this.configData = data;
            this.children[0].focus();
            this.$text.innerText = data.name;
            modalPlayList.links.continueWatch.links.$title.innerText = gettext('Continue watching from') + ' ' +
                parseTime(data.file.watched_time);
        }
    },
    children: [
        modalPlayList = new LayoutList({
            focusIndex: 0,
            size: 2,
            cycle: true,
            fixedData: true,
            className: 'padded',
            data: [
                {
                    name: 'continueWatch',
                    items: [
                        {
                            name: '$title',
                            className: 'title',
                            value: gettext('Continue watching from')
                        }
                    ],
                    click: function () {
                        if ( playModal.configData.callback ) {
                            playModal.configData.callback(playModal.configData.file.watched_time);
                        }
                    }
                },
                {
                    items: [
                        {
                            className: 'title',
                            value: gettext('Watch again')
                        }
                    ],
                    click: function () {
                        if ( playModal.configData.callback ) {
                            playModal.configData.callback(0);
                        }
                    }
                }
            ],
            events: {
                'click:item': function () {
                    playModal.hide();
                    panelSet.focus();
                },
                keydown: function ( event ) {
                    LayoutList.prototype.defaultEvents.keydown.call(this, event);
                    switch ( event.code ) {
                        case keys.left:
                            event.stop = true;
                            break;
                        case keys.back:
                            playModal.hide();
                            panelSet.focus();
                            event.stop = true;
                            break;
                    }
                }
            }
        })
    ]
});
page.add(playModal);


if ( DEVELOP ) {
    window.playList = playList;
    window.infoPanel = infoPanel;
    window.infoLeftList = leftList;
}


/**
 * Init page.
 */
page.once('show', function () {
    var tableNames = [
            gettext('Name:'),
            gettext('Genre:'),
            gettext('Duration:'),
            gettext('Year:'),
            gettext('Country:'),
            gettext('Director:'),
            gettext('Actors:'),
            gettext('Censored:')
        ],
        $tr, $tdTitle, $tdDescription, $table,
        index;

    if ( TARGET !== 'android-stb' && TARGET !== 'android-app' ) {
        footer.init({
            left: {
                code: keys.menu,
                action: function () {
                    panelSet.blur();
                    footer.hide();
                    actionModal.show();
                    actionModal.focus();
                }
            },
            middle: [
                {
                    code: keys.f3,
                    title: gettext('Favorite'),
                    action: favorite
                }
            ]
        });
        footer.hide();
    }


    $info = tag('div', {className: 'info'});
    $poster = tag('div', {className: 'poster'});
    $description = tag('div', {className: 'desc'});
    $favorite = tag('div', {className: 'fav'});
    $table = tag('table');
    $poster.appendChild($favorite);

    for ( index = 0; index < tableNames.length; index++ ) {
        $tdTitle = tag('td', {className: 'left theme-subhead-color'}, tableNames[index]);
        $tdDescription = tag('td');

        $tr = tag('tr', {}, $tdTitle, $tdDescription);
        $table.appendChild($tr);
        infoTable.push({line: $tr, text: $tdDescription});
    }
    $description.appendChild($table);

    textArea = new ScrollArea({
        propagate: true,
        focusable: true,
        step: 5,
        scroll: scroll = new Scrollbar(),
        events: {
            focus: function () {
                if ( TARGET !== 'android-stb' && TARGET !== 'android-app' ) {
                    footer.init({
                        left: {
                            code: keys.menu,
                            action: function () {
                                panelSet.blur();
                                footer.hide();
                                actionModal.show();
                                actionModal.focus();
                            }
                        },
                        middle: [
                            {
                                code: keys.f3,
                                title: gettext('Favorite'),
                                action: favorite
                            }
                        ]
                    });
                    footer.show();
                }

            },
            blur: function () {
                if ( TARGET !== 'android-stb' && TARGET !== 'android-app' ) {
                    footer.hide();
                }
            }
        }
    });

    textArea.$body.appendChild($poster);
    textArea.$body.appendChild($description);
    textArea.$body.appendChild($info);

    descriptionItem.add(textArea);
    descriptionItem.add(scroll);
    descriptionItem.show();
});


/**
 * Fill pages layouts.
 */
page.addListeners({
    show: function ( data ) {
        var list = [],
            genres = [],
            index;

        if ( !data || !data.data ) {
            return;
        }

        infoData = data.data.info;
        if ( DEVELOP ) {
            window.infoData = infoData;
        }

        if ( infoData.cover ) {
            $poster.style.backgroundImage = 'url(' + core.backend.host + infoData.cover + ')';
        } else {
            $poster.style.backgroundImage = '';
        }

        if ( infoData.favorite ) {
            $favorite.style.display = 'block';
        } else {
            $favorite.style.display = 'none';
        }
        infoTable[0].text.innerText = infoData.name;
        for ( index = 0; index < infoData.genres.length; index++ ) {
            genres.push(infoData.genres[index].name);
        }

        infoTable[1].text.innerText = genres.join(', ');
        infoTable[2].text.innerText = infoData.duration + ' ' + gettext('min.');
        infoTable[3].text.innerText = infoData.year + (infoData.year_end && infoData.year_end !== '0' ? (' - ') + infoData.year_end : '');
        infoTable[4].text.innerText = infoData.country;
        infoTable[5].text.innerText = infoData.director;
        infoTable[6].text.innerText = infoData.actors;
        if ( !infoData.rating_mpaa && !infoData.age ) {
            infoTable[7].line.style.display = 'none';
        } else {
            infoTable[7].line.style.display = '';
            infoTable[7].text.innerText = '';
            if ( infoData.age ) {
                infoTable[7].text.innerText += infoData.age;
            }
            if ( infoData.rating_mpaa ) {
                infoTable[7].text.innerText += infoData.age ? ' (' + infoData.rating_mpaa + ')' : infoData.rating_mpaa;
            }
        }
        $info.innerText = infoData.description;

        if ( infoData['is_tv_series'] ) {
            playText = gettext('Seasons');
            types.active = types.season;
            infoData.getSeasons(function ( error, seasons ) {
                debug.fail('Request error', error);
                list = prepareSeasons(seasons);
                playList.setData({focusIndex: 0, data: list});
            });
        } else {
            playText = gettext('Play');
            types.active = types.file;
            list = prepareFiles(infoData, infoData.files);
            playList.setData({focusIndex: 0, data: list});
        }

        descriptionItem.show();
        infoPanel.title.links.$name.innerText = gettext('Description');
        if ( TARGET === 'android-stb' || TARGET === 'android-app' ) {
            if ( infoData.favorite ) {
                leftList.links.favorite.links.$icon.className = 'theme-icon theme-icon-favorite-active active';
                leftList.links.favorite.links.$title.innerText = gettext('Remove from favorites');
            } else {
                leftList.links.favorite.links.$icon.className = 'theme-icon theme-icon-favorite';
                leftList.links.favorite.links.$title.innerText = gettext('Add to favorite');
            }
        }
        leftList.focusIndex(0);
        panelSet.show();
        infoPanel.focus();
        textArea.init();
    },

    keydown: function ( event ) {
        switch ( event.code ) {
            case keys.back:
                moveBack();
                break;
            case keys.left:
                infoPanel.emit('keydown', event);
                break;
        }
    }
});


module.exports = page;
